import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import type { PublicationItemInfo } from "./useTaskDetailSubscription";
import type { PreviewSibling } from "./useTaskDetailActions";
import { IfPermission } from "../../auth/IfPermission";
import { VariationPublicationRows } from "./VariationPublicationRows";
import type { JSX } from "react";

export type VariationInfo = { id: string; index: number };

export const PUBLICATION_ITEM_STATUS_COLORS: Record<
  PublicationItemInfo["status"],
  "default" | "warning" | "success" | "error"
> = {
  pending: "warning",
  published: "success",
  failed: "error",
};

export function ArticleVariations(props: {
  variations: VariationInfo[];
  publicationItems: PublicationItemInfo[] | null;
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  let articleVariations: JSX.Element | null;
  if (props.variations.length === 0) {
    articleVariations = null;
  } else {
    if (props.publicationItems !== null) {
      articleVariations = (
      <VariationPublicationRows
        variations={props.variations}
        publicationItems={props.publicationItems}
        onViewVariation={props.onViewVariation}
      />
    );
    } else {
      articleVariations = (
    <IfPermission permission="generation.view">
      <Box>
        {props.variations.map((value) => (
          <Button
            key={value.id}
            size="small"
            variant="text"
            onClick={() => props.onViewVariation(value.id, props.variations)}
            sx={{ mr: 0.5, minWidth: 0 }}
          >
            #{value.index}
          </Button>
        ))}
      </Box>
    </IfPermission>
  );
    }
  }
  return articleVariations;
}
